import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { Helmet } from "react-helmet";

const ProductDetail = () => {
  const { productId } = useParams();
  const [product, setProduct] = useState(null);
  const [selectedImage, setSelectedImage] = useState("");

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const response = await axios.get(
          `https://ryc-soluciones-nicaragua.com/api/index.php?getProductById=true&product_id=${productId}`
        );
        setProduct(response.data);
        setSelectedImage(response.data.image || response.data.photos[0] || "");
      } catch (error) {
        console.error("Error al obtener el producto:", error);
      }
    };

    fetchProduct();
  }, [productId]);

  const getYouTubeEmbedUrl = (url) => {
    if (!url) return null;
  
    let videoId = null;
  
    if (url.includes("watch?v=")) {
      videoId = url.split("watch?v=")[1]?.split("&")[0];
    } else if (url.includes("/shorts/")) {
      videoId = url.split("/shorts/")[1]?.split("?")[0];
    }
  
    return videoId ? `https://www.youtube.com/embed/${videoId}` : null;
  };
  

  if (!product) return <p className="text-center mt-5">Cargando producto...</p>;

  const videoEmbedUrl = getYouTubeEmbedUrl(product.video_url);

  const videoEmbedUrl2 = getYouTubeEmbedUrl(product.video_url2);

  return (
    <div className="container mt-4">
      <Helmet>
        <meta property="og:title" content={product.name} />
        <meta property="og:description" content={product.name} />
        <meta property="og:url" content={`https://ryc-soluciones-nicaragua.com/ryc-soluciones/#/producto/${product.id}`} />
        <meta property="og:image" content={selectedImage || product.image} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={product.name} />
        <meta name="twitter:description" content={product.name} />
        <meta name="twitter:image" content={selectedImage || product.image} />
      </Helmet>
      <h2 className="text-center" style={{ color: "#00377b" }}>{product.name}</h2>
      <div className="row mt-4 mb-4">
        <div className="col-md-6">
          {/* Imagen principal */}
          <img
            src={selectedImage}
            className="card-img-top img-fluid"
            alt={product.name}
            style={{ maxHeight: "400px", objectFit: "contain" }}
          />
          <div className="d-flex justify-content-center mt-3">
          {product.photos?.map((photo, index) => (
            <img
              key={index}
              src={photo.url_photo}
              alt={`Miniatura ${index + 1}`}
              className="img-thumbnail mx-2"
              style={{ width: "80px", height: "80px", cursor: "pointer" }}
              onClick={() => setSelectedImage(photo.url_photo)}
            />
          ))}
          </div>
        </div>

        <div className="col-md-6">
        <p className="mb-1 is-size-9">Precio:</p>
                  <p className="fs-5 mb-0 is-size-4" style={{ color: "#00377b" }}>
                    {parseFloat(product.price).toLocaleString("es-NI", {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                    })}
                    {" "}
                    {product.currency}
                  </p>
          <p>{product.description}</p>
          <h6>Características:</h6>
          <ul style={{ listStyleType: "none", paddingLeft: "0" }}>
            {product.features.map((feature, index) => (
              <li key={index}>
                <i className="fas fa-thumbs-up" style={{ marginRight: "8px" , color: "red" }}></i>{" "}
                {feature.feature}
              </li>
            ))}
          </ul>
          <a
                className="btn btn-success bottom-0 end-0 m-2 p-2 d-flex align-items-center justify-content-center"
                style={{ boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.3)", fontSize: "14px" }}
                href={(() => {
                  const phone = "50577005446";
                  const text = `Hola+estoy+interesado+en+este+producto:%0D%0A%0D%0A*${encodeURIComponent(product.name)}*%0A*Precio:*%20${encodeURIComponent(product.price)}%0A*URL:*%20https%3A%2F%2Fryc-soluciones-nicaragua.com%2Fproducto%2F${encodeURIComponent(product.id)}`;

                  // Detectar si el usuario está en móvil
                  const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

                  return isMobile
                    ? `https://wa.me/${phone}?text=${text}`
                    : `https://web.whatsapp.com/send?phone=${phone}&text=${text}`;
                })()}
                title={`Hablar sobre ${product.name} en WhatsApp`}
                target="_blank"
                rel="noopener noreferrer"
              >
                Consultar<i className="fab fa-whatsapp" style={{ fontSize: "24px", color: "white" }}></i>
              </a>
          <Link
            to="/"
            className="d-flex align-items-center justify-content-center gap-2 text-uppercase"
            style={{
              padding: "6px 12px",
              backgroundColor: "#00b5e2",
              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
              color: "white",
              fontWeight: "bold",
              fontSize: "16px",
              textDecoration: "none",
              alignItems: "center",
              justifyContent: "center",
              transition: "all 0.3s ease-in-out",
              borderRadius: "20px",
            }}
          >
            <i className="fas fa-shopping-cart"></i>
            Ver más productos
          </Link>
        </div>
      </div>

      {/* Sección del video */}
{(videoEmbedUrl || videoEmbedUrl2) && (
  <div className="row mt-4 justify-content-center">
    <div className={`col-${videoEmbedUrl && videoEmbedUrl2 ? "6" : "12"} text-center`}>
      <h5 style={{ color: "#00377b" }}>Video del producto</h5>
      <div className="embed-responsive embed-responsive-16by9" style={{ maxWidth: "600px", margin: "0 auto" }}>
        <iframe
          className="embed-responsive-item"
          width="100%"
          height="315"
          src={videoEmbedUrl}
          title="Video del producto"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
    </div>

    {videoEmbedUrl2 && (
      <div className="col-6 text-center">
        <h5 style={{ color: "#00377b" }}>Video adicional</h5>
        <div className="embed-responsive embed-responsive-16by9" style={{ maxWidth: "600px", margin: "0 auto" }}>
          <iframe
            className="embed-responsive-item"
            width="100%"
            height="315"
            src={videoEmbedUrl2}
            title="Video adicional"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    )}
  </div>
)}

    </div>
  );
};

export default ProductDetail;
